module.exports = __webpack_public_path__ + "6dc6fed18ecfbebfbf9403a6c7df6515.svg";